<template>
  <div class="device_control_page_wraper">
    <div
      v-show="userControlData.openState === 0"
      class="device_control_page_background_wraper"
      :class="userControlData.openState === 0 ? 'fade_in_public':'fade_out_public' "
    ></div>
    <div class="close_img_top public_z_index6">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>
    <div class="devce_name public_z_index6 z_ellipsis1">{{objData.remark}}</div>
    <div class="switch_temp_wraper">
      <control-switch-btn
        class="public_z_index6"
        :switchState="userControlData.openState"
        @switchStateChange="ControlSwitchBtnValue"
      ></control-switch-btn>
      <div v-if="environmentStatus" class="control-environment-status public_z_index6">{{environmentStatus}}</div>
    </div>

    <!-- <temp-set class="temp_set_08" :value="userControlData.openStateValue1" @valueChange="tempValueChange"></temp-set> -->
    <newtrend-mode
      class="newtrend_mode_018"
      :setMode="userControlData.openStateValue"
      @airModeChange="airModeChange"
    ></newtrend-mode>

    <wind-speed
      class="wind_speed_018"
      :width="180"
      :setWindSpeed="userControlData.openStateValue2"
      @windSpeedChange="windSpeedChange"
    ></wind-speed>

    <div class="btn_wraper">
      <div class="btn_return public_control_click public_z_index6" @click="$closeControlToast">返回取消</div>
      <div
        class="btn_determine public_control_click public_z_index6"
        @click="determineBtnHandle"
      >确定设置</div>
    </div>
  </div>
</template>

<script>
import {formatEnvironmentStatus} from '@/components/content/contro-view/device-view/device-item-view-js';
import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";

import ControlSwitchBtn from "components/common/control-switch-btn/control-switch-btn";
// import TempSet from "components/common/tempset/temp-set";
import WindSpeed from "components/common/wind-speed/wind-speed";
import NewtrendMode from "components/common/newtrend-mode/newtrend-mode";
export default {
  data() {
    return {
      userControlData: {
        openState: this.objData.openState, ///1开 或0关
        openStateValue: this.objData.openStateValue, ////1,内循环 2，外循环
        openStateValue1: this.objData.openStateValue1, ///无用
        openStateValue2: this.objData.openStateValue2 ///1 自动 2低速 4中速 6高速
      }
    };
  },
  props: {
    objData: Object, ///要控制设备的数据
    deviceTemp: {
      ///要显示的当前温度
      default: "--"
    }
  },
  components: {
    ControlSwitchBtn,
    WindSpeed,
    NewtrendMode
  },
  watch: {
    "objData.openState": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openState = val;
      }
    },
    "objData.openStateValue": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openStateValue = val;
      }
    },
    "objData.openStateValue2": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openStateValue2 = val;
      }
    }
  },
  methods: {
    ControlSwitchBtnValue(data) {
      console.log("开关按钮子组件传回的值" + data);
      this.userControlData.openState = data;
    },
    windSpeedChange(data) {
      console.log("风速设置子组件传回的值" + data);
      this.userControlData.openStateValue2 = data;
    },
    airModeChange(data) {
      console.log("模式子组件传回的值" + data);
      this.userControlData.openStateValue = data;
    },
    determineBtnHandle() {
      // console.log("确定按钮点下了");
      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    }
  },
  computed: {environmentStatus(){return formatEnvironmentStatus(this.objData)}}
};
</script>

<style>
.newtrend_mode_018 {
  margin-top: 30px;
}
.wind_speed_018 {
  margin-top: 30px;
  margin-bottom: 59px;
}
</style>
